export default __webpack_public_path__ + "static/img_1_0-3f487b45a6402d6c1cacdcc48b4195cc.jpg";